import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AudioFeedbackService {
  private ctx: AudioContext | null = null;

  private getCtx(): AudioContext {
    if (!this.ctx) this.ctx = new AudioContext();
    return this.ctx;
  }

  private beep(frequency: number, duration: number, gain = 0.3, startDelay = 0): void {
    const ctx = this.getCtx();
    const osc = ctx.createOscillator();
    const gainNode = ctx.createGain();
    osc.connect(gainNode);
    gainNode.connect(ctx.destination);
    osc.frequency.value = frequency;
    const start = ctx.currentTime + startDelay;
    gainNode.gain.setValueAtTime(gain, start);
    gainNode.gain.exponentialRampToValueAtTime(0.001, start + duration);
    osc.start(start);
    osc.stop(start + duration);
  }

  modeActivated(): void {
    this.beep(880, 0.1);
    this.beep(1108, 0.15, 0.3, 0.12);
  }

  scanSuccess(): void {
    this.beep(1047, 0.12);
  }

  scanError(): void {
    this.beep(220, 0.25, 0.2);
  }
}
